import React from 'react'
import { EntityControll } from './EntityControll'

type EntityMenuItemProps = {
  className: string
  onClick: (event: React.SyntheticEvent) => void
  backgroundColor: string
}

const EntityMenuItem = ({ className, onClick, backgroundColor }: EntityMenuItemProps) => {
  return (
    <EntityControll style={{ backgroundColor }}>
      <span className={className} onClick={onClick} />
    </EntityControll>
  )
}

export default EntityMenuItem
